module.exports = __webpack_public_path__ + "img/module_jhys_icon.511fb358.png";